module.exports = __webpack_public_path__ + "img/SJYG_Android.cf5f9a99.png";